import { Brand } from 'utility-types';

export type PoolID = Brand<string, 'PoolID'>;

export enum SystemDefinedPoolID {
  Unassigned = 'UNASSIGNED',
  Default = 'DEFAULT',
  Blocked = 'BLOCKED'
}
